(function () {
  'use strict';

  var productAltCache = {};
  var productAltErrors = {};
  var productAltMap = {};
  var cardSelector = '.spf-product-card__image-wrapper[href*="/products/"]';
  var debugEnabled = new URLSearchParams(window.location.search).get('debug_alt') === '1';

  function debugLog(message, details) {
    if (!debugEnabled || !window.console) {
      return;
    }

    if (typeof details === 'undefined') {
      console.log('[ProductCardAlt] ' + message);
    } else {
      console.log('[ProductCardAlt] ' + message, details);
    }
  }

  function debugError(message, details) {
    if (!debugEnabled || !window.console) {
      return;
    }

    console.error('[ProductCardAlt] ' + message, details);
  }

  function loadProductAltMap() {
    var altMapData = document.querySelector('[data-product-card-alt-map]');

    if (!altMapData) {
      debugLog('Liquid alt map was not found in the page HTML.');
      return;
    }

    try {
      productAltMap = JSON.parse(altMapData.textContent) || {};
      debugLog('Liquid alt map loaded.', {
        productCount: Object.keys(productAltMap).length,
        values: productAltMap
      });
    } catch (error) {
      productAltMap = {};
      debugError('Liquid alt map contains invalid JSON.', error);
    }
  }

  function getProductHandle(link) {
    var productPath = new URL(link.href, window.location.origin).pathname;
    var match = productPath.match(/\/products\/([^/?#]+)/);

    return match ? decodeURIComponent(match[1]) : '';
  }

  function getProductAlt(handle) {
    if (Object.prototype.hasOwnProperty.call(productAltMap, handle)) {
      debugLog('Alt resolved from the Liquid map.', {
        handle: handle,
        alt: productAltMap[handle]
      });
      var mappedAlt = typeof productAltMap[handle] === 'string'
        ? productAltMap[handle].trim()
        : '';

      if (!mappedAlt) {
        productAltErrors[handle] = 'metafield-empty-in-liquid-map';
      }

      return Promise.resolve(mappedAlt);
    }

    if (!productAltCache[handle]) {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      var requestUrl = new URL(
        root.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle),
        window.location.origin
      );
      var currentParams = new URLSearchParams(window.location.search);

      requestUrl.searchParams.set('view', 'product-card-alt');
      ['preview_theme_id', '_fd', 'pb'].forEach(function (parameter) {
        if (currentParams.has(parameter)) {
          requestUrl.searchParams.set(parameter, currentParams.get(parameter));
        }
      });

      debugLog('Requesting product alt view.', {
        handle: handle,
        url: requestUrl.toString()
      });

      productAltCache[handle] = fetch(requestUrl.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      })
        .then(function (response) {
          debugLog('Product alt view response received.', {
            handle: handle,
            status: response.status,
            ok: response.ok
          });

          if (!response.ok) {
            throw new Error('Unable to load product image alt');
          }

          return response.text();
        })
        .then(function (html) {
          var responseDocument = new DOMParser().parseFromString(html, 'text/html');
          var altData = responseDocument.querySelector('[data-product-card-alt]');

          if (!altData) {
            debugError('Alt marker is missing from the product alt view.', {
              handle: handle,
              responseStart: html.slice(0, 300)
            });
            throw new Error('Product image alt data was not rendered');
          }

          var customAlt = JSON.parse(altData.textContent);
          debugLog('Alt parsed from the product alt view.', {
            handle: handle,
            alt: customAlt
          });
          return typeof customAlt === 'string' ? customAlt.trim() : '';
        })
        .catch(function (error) {
          debugError('Unable to resolve product alt.', {
            handle: handle,
            error: error
          });
          productAltErrors[handle] = error && error.message
            ? error.message
            : 'section-request-failed';
          delete productAltCache[handle];
          return '';
        });
    }

    return productAltCache[handle];
  }

  function updateCard(link) {
    if (link.getAttribute('data-product-alt-state')) {
      return;
    }

    var handle = getProductHandle(link);
    if (!handle) {
      debugLog('Product handle could not be read from the card.', link.href);
      return;
    }

    debugLog('Processing product card.', {
      handle: handle,
      currentAlts: Array.prototype.map.call(link.querySelectorAll('img'), function (image) {
        return image.alt;
      })
    });
    link.setAttribute('data-product-alt-state', 'loading');

    getProductAlt(handle).then(function (customAlt) {
      if (customAlt) {
        var images = link.querySelectorAll('img');
        Array.prototype.forEach.call(images, function (image) {
          image.alt = customAlt;
        });
        link.setAttribute('data-product-alt-state', 'applied');
        link.setAttribute('data-product-alt-value', customAlt);
        debugLog('Custom alt applied to the product card.', {
          handle: handle,
          alt: customAlt,
          imageCount: images.length
        });
      } else {
        link.setAttribute('data-product-alt-state', 'empty');
        link.setAttribute(
          'data-product-alt-error',
          productAltErrors[handle] || 'no-metafield-value-returned'
        );
        debugLog('No custom alt was returned for the product.', handle);
      }
    });
  }

  function updateProductCards(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches(cardSelector)) {
      updateCard(scope);
    }

    Array.prototype.forEach.call(scope.querySelectorAll(cardSelector), updateCard);
  }

  function startProductAltUpdates() {
    var productGrid = document.querySelector('[data-globo-filter-items]');
    if (!productGrid) {
      debugLog('Globo product grid was not found.');
      return;
    }

    debugLog('Product alt diagnostics started.', {
      grid: productGrid,
      page: window.location.href
    });
    loadProductAltMap();
    updateProductCards(productGrid);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) {
            updateProductCards(node);
          }
        });
      });
    }).observe(productGrid, { childList: true, subtree: true });

    window.addEventListener('globoFilterRenderCompleted', function () {
      debugLog('globoFilterRenderCompleted event received.');
      updateProductCards(productGrid);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startProductAltUpdates);
  } else {
    startProductAltUpdates();
  }
})();
